import { EPropertyType } from '../Schema'
import { SchemaProperty } from './SchemaProperty'

export class BooleanSchemaProperty extends SchemaProperty {
  public readonly type = EPropertyType.BOOLEAN
}
